export const transition = {
    duration: .25,
    ease: [.56, .03, .12, 1.04]
};


export const variants = {
    hideMessage: {
        opacity: 0,
        y: '-.5rem'
    },
    showMessage: {
        opacity: 1,
        y: 0
    },
    hideIcon: {
        opacity: 0,
        x: '.5rem'
    },
    showIcon: {
        opacity: 1,
        x: 0
    },
    hide: {
        opacity: 0
    },
    show: {
        opacity: 1
    }
};